import styles from './styles.module.css'

const AperturaContainerDestacado = (props) => {
    const { title, link, title1, link1, title2, link2, title3, link3, titleVideo, linkNotaVideo, urlVideo = '' } = props;
    let urlIframe;
    if (urlVideo.indexOf('youtube') != -1) {
        let regexYoutube = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|(?:v|l(?:ive)?)\/|(?:v|s(?:horts)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/gi;
        const idVideo = regexYoutube.exec(urlVideo)
        urlIframe = `https://www.youtube.com/embed/${idVideo[1]}?autoplay=1&mute=1`;
    }
    if (urlVideo.indexOf('youtu') != -1) {
        let regexYoutube = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|(?:v|l(?:ive)?)\/|(?:v|s(?:horts)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/gi;
        const idVideo = regexYoutube.exec(urlVideo)
        urlIframe = `https://www.youtube.com/embed/${idVideo[1]}?&autoplay=1&mute=1`;
    }

    return (
        <div className={`${styles["AperturaContainerDestacado-p"]}`}>

        {title &&  <div className={`${styles["contenedor-gral-tittulo-container"]}`}>
                <div className={`${styles["contenedor-left-titulo"]}`}>
                    <h2><a href={link}>{title}</a></h2>
                </div>
            
            <div className={`${styles["scroll-margin"]}`}>
                <nav className={`${styles["menu-el-scroll"]}`}>
                <ul>
                    {link1 && title1  &&  <li><a href={link1} >{title1}</a></li>}
                    {link2 && title2  &&  <li><a href={link2} >{title2}</a></li>}
                    {link3 && title3  &&  <li><a href={link3} >{title3}</a></li>}                
                </ul>
                </nav>
            </div>
            </div> 
            }

            <div className={`${styles["AperturaContainerDestacado-parent"]}`}>
            <div className={`${styles['primer-bloque']}`}>
            {props.renderContainerWidgetCallback(1, "DestacadaAperturaInContainers")}
            </div>            
            <div className={`${styles['tercer-bloque']}`}>
            {props.renderContainerWidgetCallback(2, "SegundoModuloDestacado")}
            </div>
            <div className={`${styles['cuarto-bloque']}`}>
            {props.renderContainerWidgetCallback(3, "SegundoModuloDestacado")}
            </div>
            </div>
        </div>
    )
}
export default AperturaContainerDestacado